// extracted by mini-css-extract-plugin
export default {"list":"elements_list__IAJkW"};